import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = ({ dealership }) => {
  const voucherCurrency = dealership?.voucherCurrency || 'Euro';
  const partnerName = dealership?.name || 'Ihrem Partner';

  const premium2026 = Number(dealership?.premium2026 ?? dealership?.voucherValue ?? 150);
  const premium2027 = Number(dealership?.premium2027 ?? 0);
  const totalPremium = premium2026 + premium2027;
  const has2027 = premium2027 > 0;

  const benefits = [
    {
      icon: 'Gift',
      title: `Bis zu ${totalPremium} ${voucherCurrency} Gutschein`,
      description: `Einlösbar bei ${partnerName} – für Service, Wartung, Werkstattarbeiten oder Teile & Zubehör.`
    },
    {
      icon: 'CalendarCheck',
      title: has2027 ? '2026 & 2027 auf einmal' : '2026 jetzt registrieren',
      description: has2027
        ? 'Jetzt beide Jahre gleichzeitig registrieren – maximaler Vorteil, kein erneuter Aufwand.'
        : `${premium2026} ${voucherCurrency} Gutschein für Ihre THG-Quote 2026 sichern.`
    },
    {
      icon: 'Shield',
      title: 'Sicher & transparent',
      description: 'Datenschutzkonform, zuverlässig und ohne versteckte Kosten. Gutschein erst nach Prüfung.'
    },
    {
      icon: 'Zap',
      title: 'In wenigen Minuten erledigt',
      description: 'Formular ausfüllen, Fahrzeugschein hochladen – wir kümmern uns um alles Weitere.'
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            Ihr Vorteil bei {partnerName}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {has2027
              ? `Registrieren Sie Ihr Elektroauto für 2026 und 2027 – und sichern Sie sich bis zu ${totalPremium} ${voucherCurrency} Gutschein, einlösbar bei ${partnerName}.`
              : `Registrieren Sie Ihr Elektroauto für 2026 – und sichern Sie sich ${premium2026} ${voucherCurrency} Gutschein, einlösbar bei ${partnerName}.`
            }
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth"
            >
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                style={dealership?.ciPrimaryColor ? { 
                  backgroundColor: dealership?.ciPrimaryColor,
                  borderColor: dealership?.ciPrimaryColor,
                  borderWidth: '3px',
                  borderStyle: 'solid'
                } : { backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name={benefit?.icon} size={24} color={dealership?.ciPrimaryColor ? '#ffffff' : 'var(--color-primary)'} />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                {benefit?.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;